import React from "react";
import { useEffect, useState, useContext } from "react";
import ProductsView from "../components/ProductsView";
import AdminProductsView from "../components/AdminProductsView";
import UserContext from "../context/UserContext";

function Products() {
  const { user } = useContext(UserContext);
  const [products, setProducts] = useState([]);

  const fetchProducts = async () => {
    let url =
      user && user.isAdmin
        ? `${process.env.REACT_APP_API_BASE_URL}/products/all`
        : `${process.env.REACT_APP_API_BASE_URL}/products/active`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.log("url:", url);
      console.log("Products fetched:", data);
      setProducts(data); // Uncomment if you want to store products in state
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [user]);

  return (
    <>
      {user && user.isAdmin ? (
        <AdminProductsView products={products} setProducts={setProducts} />
      ) : (
        <ProductsView
          products={products}
          setProducts={setProducts}
          fetchProducts={fetchProducts}
        />
      )}
    </>
  );
}

export default Products;
